import React from 'react';

/**
 * The DanceHall Studios wordmark, stacked: "DanceHall" in the heading serif
 * with "Studios" in script centred underneath, never overlapping.
 *
 * One component so every surface renders the same mark. `size` scales the
 * whole lockup; `tone` flips it for dark backgrounds. `topClassName` replaces the
 * top line's styling (and sets it in caps) — only the NYKF page uses it, to match
 * the festival masthead. Don't reach for it elsewhere.
 */
const SIZES = {
  sm: { top: 'text-xl', script: 16, gap: '-mt-1' },
  md: { top: 'text-2xl', script: 21, gap: '-mt-1' },
  lg: { top: 'text-4xl', script: 28, gap: '-mt-1.5' },
};

export default function Wordmark({ size = 'md', tone = 'light', className = '', topClassName }) {
  const s = SIZES[size] || SIZES.md;
  const topColor = tone === 'dark' ? 'text-white' : 'text-gray-900';
  const scriptColor = tone === 'dark' ? 'text-brand-200' : 'text-brand-900';
  return (
    <span className={`inline-flex flex-col items-center leading-none ${className}`} aria-label="DanceHall Studios">
      <span className={topClassName || `font-heading ${s.top} font-bold tracking-tight ${topColor}`}>
        {topClassName ? 'DANCEHALL' : 'DanceHall'}
      </span>
      <span
        className={`${scriptColor} whitespace-nowrap ${s.gap}`}
        style={{ fontFamily: "'Dancing Script', cursive", fontWeight: 700, fontSize: `${s.script}px`, lineHeight: 1.1 }}
      >
        Studios
      </span>
    </span>
  );
}
